import { PartyPlaceMergePartyPlaceModel } from 'app/generated/backend/yard/api/party-place-merge-party-place-model';
export class PartyPlaceMergeModel {
	id: number;
	mergePartyPlaceId: number;
	mergedPartyPlaces: PartyPlaceMergePartyPlaceModel[];
}
